import React, {useEffect, useState} from "react";
import {Affix, Button, Checkbox, Col, Input, InputNumber, List, Popconfirm, Row, Switch} from "antd";
import i18next from "i18next";
import * as Setting from "../../conf/Setting";
import * as IconFont from "../../components/common/IconFont";
import * as PasswordPolicyBackend from "../../services/PasswordPolicyBackend";
import moment from "moment";
import {v4 as uuidv4} from "uuid";
import "../../assets/styles/password/PasswordPolicyPage.less";

export const PasswordPolicyPage = (props) => {
  const newPasswordConfig = () => {
    const randomName = Setting.getRandomName();
    return {
      owner: Setting.Admin,
      uid: uuidv4(),
      displayName: `新策略 - ${randomName}`,
      createdTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      pwdLength: 8,  // 密码最小长度
      pwdComplexity: ["number_letter", "special_letter", "lower_letter"],  // 密码复杂度
      checkValidity: true,  // 密码有效期 是否开启校验
      validityPeriod: 90, // 有效期（天）
      reminder: 7,  // 过期前X天提醒
      tryCount: 3,  // 最多尝试次数
      lockTime: 30, // 锁定时长（分钟）
      checkUserInfo: false, // 开启则检查密码不可包含用户名、手机号、邮箱前缀、姓名拼音
      isForbidden: false, // 是否禁用， true表示禁用
      isDefault: false, // 是默认配置 （此处所有新建的均传递false） （该字段用户判断默认配置不可修改，不可删除）
    };
  };

  const [dataList, setDataList] = useState([]);
  const [policy, setPolicy] = useState(null);
  const [mode, setMode] = useState("");
  const [currentSelect, setCurrentSelect] = useState(-1);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [loadingForbidden, setLoadingForbidden] = useState(false);
  const [originConfig, setOriginConfig] = useState(null);
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    PasswordPolicyBackend.getConfigs().then(res => {
      if (res.msg === undefined) {
        const list1 = res.filter(config => !config.isDefault);
        const list2 = res.filter(config => config.isDefault);
        const list = [...list2, ...list1];
        if (list.length > 0) {
          setMode("");
          setCurrentSelect(0);
          getConfig(list[0].owner, list[0].uid);
        }
        setDataList(list);
      } else {
        Setting.showResponseMessage(res.msg);
      }
    }).catch(error => {
      Setting.showResponseMessage(error);
    });
  };

  const getConfig = (owner, uid) => {
    PasswordPolicyBackend.getConfig(owner, uid).then (res => {
      if (res.msg === undefined) {
        setPolicy(res);
      }
    });
  };

  const parseUserField = (key, value) => {
    if (["pwdLength", "validityPeriod", "reminder", "tryCount", "lockTime"].includes(key)) {
      value = Setting.myParseInt(value);
    }
    return value;
  };

  const updatePolicyField = (key, value) => {
    value = parseUserField(key, value);

    setPolicy({
      ...policy,
      [key]: value,
    });
  };

  const onClickAddNewPolicy = () => {
    setLoadingAdd(true);
    const config = newPasswordConfig();
    PasswordPolicyBackend.addConfig(config)
      .then(resAdd => {
        if (resAdd.status === "ok") {
          PasswordPolicyBackend.getConfigs().then(res => {
            setLoadingAdd(false);
            if (res.msg === undefined) {
              const list1 = res.filter(config => !config.isDefault);
              const list2 = res.filter(config => config.isDefault);
              const list = [...list2, ...list1];
              setDataList(list);
              if (list.length > 0) {
                setMode("add");
                const foundIndex = list.findIndex(item => item.uid === config.uid);
                setCurrentSelect(foundIndex);
                const policyTemp = Setting.deepCopy(list[foundIndex]);
                getConfig(policyTemp.owner, policyTemp.uid);
              }
            } else {
              Setting.showResponseMessage(res.msg);
            }
          }).catch(error => {
            setLoadingAdd(false);
            Setting.showResponseMessage(error);
          });
        } else {
          setLoadingAdd(false);
          Setting.showResponseMessage(resAdd.msg);
        }
      })
      .catch(error => {
        setLoadingAdd(false);
        Setting.showResponseMessage(error);
      });
  };

  const onClickSave = () => {
    if (policy.displayName.trim() === "") {
      Setting.showResponseMessage(i18next.t("password:Please input display name"));
      return;
    }

    if (policy.pwdComplexity.length === 0) {
      Setting.showResponseMessage(i18next.t("password:Please select at least one complexity"));
      return;
    }

    setLoadingSave(true);
    PasswordPolicyBackend.updateConfig(policy, policy.owner, policy.uid)
      .then(res => {
        setLoadingSave(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          setDataList(dataList.map(item => {
            if (item.uid === policy.uid) {
              return policy;
            }
            return item;
          }));
          setOriginConfig(policy);
          setMode("");
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setLoadingSave(false);
        Setting.showResponseMessage(error);
      });
  };

  const onClickFobidden = (state) => {
    setLoadingForbidden(true);
    const newPolicy = {
      ...policy,
      isForbidden: state,
    };
    PasswordPolicyBackend.updateConfig(newPolicy, newPolicy.owner, newPolicy.uid)
      .then(res => {
        if (res.status === "ok") {
          setLoadingForbidden(false);
          updatePolicyField("isForbidden", newPolicy.isForbidden);
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setLoadingForbidden(false);
        Setting.showResponseMessage(error);
      });
  };

  const onClickDelete = () => {
    PasswordPolicyBackend.deleteConfig(policy)
      .then(res => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("password:Password policy deleted successfully"));
          getDataList();
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  };

  const onClickCancel = () => {
    if (mode === "add") {
      setLoadingCancel(true);
      PasswordPolicyBackend.deleteConfig(policy)
        .then(res => {
          setLoadingCancel(false);
          if (res.status === "ok") {
            getDataList();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          setLoadingCancel(false);
          Setting.showResponseMessage(error);
        });
    } else {
      setPolicy(originConfig);
      setMode("");
    }
  };

  const renderContent = () => {
    const disbaled = !(mode === "add" || mode === "edit") ;

    return <div className="ua-password-policy-input" style={{marginLeft: 32}}>
      {
        policy?.isDefault ? null :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
              {Setting.getLabel(i18next.t("password:Display name"), i18next.t("password:Display name - Tooltip"), true)} :
            </Col>
            <Col span={10} >
              <Input
                maxLength={20}
                showCount={true}
                disabled={disbaled || policy?.isDefault}
                value={policy?.displayName}
                placeholder={i18next.t("password:Please input display name")}
                onChange={e => {
                  updatePolicyField("displayName", e.target.value);
                }} />
            </Col>
          </Row>
      }
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
          {Setting.getLabel(i18next.t("password:Min Length"), i18next.t("password:Min Length - Tooltip"), true)} :
        </Col>
        <Col span={5} >
          <InputNumber
            min={4}
            max={30}
            disabled={disbaled}
            value={policy?.pwdLength}
            onChange={e => {
              updatePolicyField("pwdLength", e);
            }} />
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
          {Setting.getLabel(i18next.t("password:Complexity"), i18next.t("password:Complexity - Tooltip"), true)} :
        </Col>
        <Col span={16} >
          <Checkbox.Group disabled={disbaled} options={Setting.passwordComplexity} value={policy?.pwdComplexity} onChange={checkedValue => {
            updatePolicyField("pwdComplexity", checkedValue);
          }} />
          <span>({i18next.t("password:Please select one at least")})</span>
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
          {Setting.getLabel(i18next.t("password:Expires"), i18next.t("password:Expires - Tooltip"), true)} :
        </Col>
        <Col span={10} >
          <Switch disabled={disbaled} checked={policy?.checkValidity} onChange={checked => {
            updatePolicyField("checkValidity", checked);
          }} />
        </Col>
      </Row>
      {
        !policy?.checkValidity ? null
          :
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
            </Col>
            <Col span={12} style={{display: "flex", alignItems: "center"}}>
              <Col style={{width: 90}}>
                <InputNumber
                  min={1}
                  maxLength={4}
                  disabled={disbaled}
                  value={policy?.validityPeriod}
                  onChange={e => {
                    updatePolicyField("validityPeriod", e);
                  }} />
              </Col>
              <div style={{marginLeft: 8}}>{i18next.t("password:days expired")}</div>
              <Col span={4}></Col>
              <div style={{marginRight: 8, whiteSpace: "nowrap"}}>{i18next.t("password:before")}</div>
              <Col style={{width: 90}}>
                <InputNumber
                  min={1}
                  maxLength={4}
                  disabled={disbaled}
                  value={policy?.reminder}
                  onChange={e => {
                    updatePolicyField("reminder", e);
                  }} />
              </Col>
              <div style={{marginLeft: 8, whiteSpace: "nowrap"}}>{i18next.t("password:day of expires")}</div>
            </Col>
          </Row>
      }
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
          {Setting.getLabel(i18next.t("password:Try count"), i18next.t("password:Try count - Tooltip"), true)} :
        </Col>
        <Col span={12} style={{display: "flex", alignItems: "center"}}>
          <Col style={{width: 90}}>
            <InputNumber
              min={1}
              maxLength={5}
              disabled={disbaled}
              value={policy?.tryCount}
              onChange={e => {
                updatePolicyField("tryCount", e);
              }} />
          </Col>
          <div style={{marginLeft: 8}}>{i18next.t("password:times")}</div>
          <Col span={5}></Col>
          <div style={{marginRight: 8, whiteSpace: "nowrap"}}>{i18next.t("password:Lock time")}</div>
          <Col style={{width: 90}}>
            <InputNumber
              min={1}
              maxLength={5}
              disabled={disbaled}
              value={policy?.lockTime}
              onChange={e => {
                updatePolicyField("lockTime", e);
              }} />
          </Col>
          <div style={{marginLeft: 8, whiteSpace: "nowrap"}}>{i18next.t("password:minutes")}</div>
        </Col>
      </Row>
      <Row style={{marginTop: "20px"}} >
        <Col style={{marginTop: "5px", marginRight: "10px", textAlign: "right"}} span={(Setting.isMobile()) ? 22 : 4}>
          {Setting.getLabel(i18next.t("password:User info check"), i18next.t("password:User info check - Tooltip"))} :
        </Col>
        <Col span={10} >
          <Switch disabled={disbaled} checked={policy?.checkUserInfo} onChange={checked => {
            updatePolicyField("checkUserInfo", checked);
          }} />
          <div style={{color: "#999999", fontSize: 12}}>
            {i18next.t("password:When it is on, password can not include username、phone、email and name")}
          </div>
        </Col>
      </Row>
    </div>;
  };

  const opButtonStyle = {
    minWidth: "70px",
    height: "32px",
    marginRight: "12px",
    borderRadius: "2px",
  };

  return (
    <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
      <Row style={{flex: 1}}>
        <Col span={4} style={{background: "#F5FBFF", textAlign: "center",
          overflow: "auto",
          height: "calc(100vh - 130px)",
        }}>
          <List
            className="ua-password-policy-list"
            header={<div style={{height: 1}}></div>}
            split={false}
            dataSource={dataList}
            renderItem={(item, index) => (
              <div className={`ua-password-policy-list-item ${index === currentSelect ? "ua-password-policy-list-item-selected" : ""}`}
                onClick={() => {
                  if (index !== currentSelect) {
                    setMode("");
                    setCurrentSelect(index);
                    getConfig(item.owner, item.uid);
                  }
                }}>
                {item.displayName}
              </div>
            )
            }
          />
          <Affix offsetBottom={30} style={{height: 56}}>
            <div style={{background: "#F5FBFF"}}>
              <Button icon={<IconFont.PlusIcon />} style={{marginTop: 10, background: "transparent", width: "calc(100% - 48px)", borderRadius: "2px"}}
                onClick={onClickAddNewPolicy} loading={loadingAdd}>{i18next.t("password:New Policy")}</Button>
            </div>
          </Affix>
        </Col>
        <Col span={20} style={{border: "1px solid #EEEEEE"}}>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <div style={{fontSize: 16, fontWeight: 600, color: "#333333", marginTop: 21, marginLeft: 32}}>{policy?.displayName}</div>
            <div style={{marginTop: 21}}>
              {
                mode !== "" || policy?.isDefault ? null :
                  policy?.isForbidden ?
                    <Button type="primary" ghost style={opButtonStyle}
                      disabled={policy?.isDefault}
                      loading={loadingForbidden}
                      onClick={() => {
                        onClickFobidden(false);
                      }}>
                      {i18next.t("general:Enable")}
                    </Button>
                    :
                    <Popconfirm
                      title={`${i18next.t("password:Sure to disable this password policy")}`}
                      onConfirm={() => onClickFobidden(true)}
                      placement="bottomRight"
                      disabled={policy?.isDefault}
                    >
                      <Button type="primary" ghost style={opButtonStyle} disabled={policy?.isDefault}>
                        {i18next.t("general:Disable")}
                      </Button>
                    </Popconfirm>

              }
              {
                mode !== "" || policy?.isDefault ? null :
                  <Popconfirm
                    title={`${i18next.t("password:Sure to delete this password policy")}`}
                    onConfirm={() => onClickDelete()}
                    placement="bottomRight"
                    disabled={policy?.isDefault}
                  >
                    <Button type="primary" ghost style={opButtonStyle} disabled={policy?.isDefault}>
                      {i18next.t("general:Delete")}
                    </Button>
                  </Popconfirm>
              }
              {
                mode === "" ? null :
                  <Button type="default" style={opButtonStyle} onClick={onClickCancel} loading={loadingCancel}>
                    {i18next.t("general:Cancel")}
                  </Button>
              }
              {
                mode === "add" || mode === "edit" ?
                  <Button loading={loadingSave} type="primary" style={opButtonStyle} onClick={onClickSave}>
                    {i18next.t("general:Save")}
                  </Button>
                  :
                  <Button type="primary" style={opButtonStyle} onClick={() => {
                    setMode("edit");
                    setOriginConfig(policy);
                  }}>
                    {i18next.t("general:Edit")}
                  </Button>
              }
            </div>
          </div>
          {renderContent()}
        </Col>
      </Row>
    </div>
  );
};

export default PasswordPolicyPage;
